import { render, staticRenderFns } from "./lmcm.vue?vue&type=template&id=0641ada6&scoped=true"
import script from "./lmcm.vue?vue&type=script&lang=js"
export * from "./lmcm.vue?vue&type=script&lang=js"
import style0 from "./lmcm.vue?vue&type=style&index=0&id=0641ada6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0641ada6",
  null
  
)

export default component.exports